import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeName:0,
  },
  getters: {
  },
  mutations: {
    SET_ACTIVE(state, data) {
      //消息通知参数
      state.activeName = data;
    },
  },
  actions: {
  },
  modules: {
  }
})
